//Probably all loading at once, so keep option of returning function that returns JSX rather than the straight JSX?
// next time, import a link component that includes open new tab properties with href and children passed as prop.
//This is why CMSs exist. Find out how to manage these without hard-coding JSX.

export const data = {
    "Arizona":{
        "name": "The Grand Canyon State",
        "text": (
                    <>
                        <p> 
                            Estimates from the U.S. Census Bureau place around&nbsp; 
                            <a href='https://www.census.gov/quickfacts/AZ' target='_blank' rel="noreferrer">
                            7.4 million residents&nbsp; 
                            </a>
                            in the state of Arizona in 2022. Around 90 percent of them live in urban areas, according to a 2020&nbsp;
                            <a href='https://crh.arizona.edu/sites/default/files/2022-03/20210702_AZ_BH_WorkforceReport_FINAL_0.pdf' target='_blank' rel="noreferrer">
                            analysis&nbsp; 
                            </a> 
                            by the University of Arizona. Displayed beside county names are net changes of that county's populations from 2010 to 2023.<br/><br/>
                            Drag, click, zoom, and explore 
                            this model of the state's 15 counties.
                        </p>
                    </>
        )
    },
    "Apache": {
        "name": "Apache County",
        "text": (
                    <>
                         <p>
                            High on the cooler but drier Colorado plateau,
                             this county hosts a large part of the&nbsp;
                             <a href="https://musnaz.org/on-view/native-peoples-of-the-colorado-plateau/navajo/?gclid=CjwKCAjwscGjBhAXEiwAswQqNDz6KySFhNCXtp7owyhl3M8qm2HFarq_7FKP-EkCz9NTNcJRhBe77BoCzDQQAvD_BwE" target='_blank' rel="noreferrer">
                                 Navajo Nation</a>,&nbsp;
                             <a href="http://www.wmat.nsn.us/wmahistory.shtml" target='_blank' rel="noreferrer">
                                Fort Apache</a>, and some of the&nbsp;
                            <a href="https://naair.arizona.edu/pueblo-zuni" target='_blank' rel="noreferrer"> 
                                Zuni Indian reservation</a>.&nbsp; 
                             The significant tribal presences here make 
                             local government heavily involved in Native 
                             American affairs. 
                        </p>
                        <p> 
                            Sparsely populated, the county encourages 
                             development but advises extensive research and 
                             planning for anyone seeking to buy and live there. 
                             “Make sure you can survive in rural areas without 
                             utilities for at least a week in severe cold weather,”  
                            states its <a href="https://www.apachecountyaz.gov/Living-in-Apache-County" target='_blank' rel="noreferrer">
                            county living page</a>. The region recieves less than 20 inches of precipitation 
                            a year, and its elevation makes for frigid winters. <br /><br /> Further reading:
                        </p>
                        <ul>
                            <li><a href="https://musnaz.org/on-view/native-peoples-of-the-colorado-plateau/apache/?gclid=CjwKCAjwscGjBhAXEiwAswQqNOZ4PIFCASTXKkmTi2-3bUtQ8KwaP6khjCkzYslx023hiFafhHnvGBoCJD0QAvD_BwE" target='_blank' rel="noreferrer">
                            Apaches in Arizona</a></li>
                            <li><a href="https://www.wmicentral.com/news/latest_news/a-plan-to-divide-the-counties/article_075759d2-33ad-517f-b598-bc40cc80da70.html" target='_blank' rel="noreferrer">
                            Conflict over county lines</a></li>
                        </ul>
                    </>
                )
    },
    "Cochise": {
        "name": "Cochise County",
        "text": (   <>
                            <p>
                                Cochise county may be known as the wild west via&nbsp; 
                                <a href="https://movieweb.com/every-wyatt-earp-western-movie-ranked/#wyatt-earp-1994" target='_blank' rel="noreferrer">
                                    Hollywood's obsession with Wyatt Earp</a>, 
                                but it's also known for its valuable raw earth materials and modern art scene. 
                                Between historic&nbsp; 
                                <a href="https://www.azcommerce.com/a/profiles/ViewProfile/129/Tombstone/" target='_blank' rel="noreferrer">
                                Tombstone </a>
                                and mining-town turned artist-refuge&nbsp;
                                <a href="https://www.azcommerce.com/a/profiles/ViewProfile/32/Bisbee/" target='_blank' rel="noreferrer">
                                Bisbee</a>
                                , the county thrives as a modern tourist destination.
                            </p>
                            <p>
                                Originally settled for silver, copper, and gold, Bisbee's Copper Queen  
                                Mine was depleted of useful ores in the 70's.&nbsp;
                                <a href="https://www.myheraldreview.com/news/bisbee/freeport-mcmoran-continues-to-reclaim-stockpiles-improve-viewsheds/article_198908c4-d879-11ec-84f4-c389011afb5e.html" target='_blank' rel="noreferrer">
                                Freeport-McMoRan has recently begun reclamation and remediation efforts </a> to re-wild
                                the land and prevent or mitigate the diarrhea that a plume of sulfurous 
                                run-off will cause in around 50 years when it finally reaches the area's wells.
                                <br/><br/>
                                Further reading:
                            </p>
                            <ul>
                                <li><a href="https://www.nationalgeographic.co.uk/history-and-civilisation/2020/03/what-really-happened-at-the-gunfight-at-the-ok-corral" target='_blank' rel="noreferrer">Gunfight at O.K. Corral</a></li>
                                <li><a href="https://www.azcentral.com/story/sponsor-story/discover-bisbee/2021/12/22/5-reasons-plan-visit-bisbee-arts-culture-district/8969955002/" target='_blank' rel="noreferrer">Bisbee Tourism</a></li>
                                
                            </ul>
                    </>
                        )
    },
    "Coconino": {
        "name": "Coconino County",
        "text": ( 
                    <>
                        <p>
                            Coconino county is best known for its natural beauty.
                            Much of the Grand Canyon National park is located in its northwest,
                            where every year more tourists are received to look over one of the
                            world’s seven natural wonders. <a href="https://www.nps.gov/grca/learn/management/statistics.htm" target='_blank' rel="noreferrer">
                            In 2022, there were almost 6.4 million estimated visitors.</a>
                        </p>
                        <p>
                            Within county borders is much of the Sedona area, which some believe is a&nbsp;
                            <a href="https://www.thrillist.com/travel/nation/sedona-energy-vortexes-explained" target='_blank' rel="noreferrer">
                            hot spot for psychic vortexes</a>. Between psychism and its psychedelic art scene, the city of Sedona acts as a secondary pull for international tourism.
                        </p>
                        <p>
                            Flagstaff is the seat of county governance and
                            host to Northern Arizona University. The city sits atop a mountain due north 
                            of Phoenix- the drive showcasing desert, chaparral, and mountain ecologies.
                            &nbsp;Already known for its environmental studies programs thanks to its proximity to such varied environments,
                            Northern Arizona University recently <a href="https://news.nau.edu/nsf-research-rankings-2021/" target='_blank' rel="noreferrer">
                            improved its national research output ranking</a>, 
                            inching closer to becoming the state’s third world-class public research university.
                            <br/><br/>
                            Further reading:
                        </p>
                        <ul>
                            <li><a href="https://visitsedona.com/shopping/art-galleries/" target='_blank' rel="noreferrer">Sedona Gallery Association</a></li>
                            <li><a href="https://visitsedona.com/blog/getting-grounded-a-guide-to-sedonas-trails/" target='_blank' rel="noreferrer">Sedona Trail Guide</a></li>  
                        </ul>
                    </>
                       )
    },
    "Gila": {
        "name": "Gila County",
        "text": ( <>
                            <p>
                               Home of the famous cliff dwellings of the <a href="https://www.americansouthwest.net/arizona/tonto/national_monument.html" target='_blank' rel="noreferrer">
                               Tonto National Monument</a>,
                               this county spreads over a geographically varied area that includes lowland 
                               desert and mountain forest. Recently, the <a href="https://www.paysonroundup.com/catastrophe_a_forest_in_flames/legislative-committee-digs-into-roots-of-wildfire-crisis/article_abce6026-9448-5112-a030-5a14d27fd980.html" target='_blank' rel="noreferrer">
                               county has struggled</a> to 
                               fight forest fires, <a href="https://ktar.com/story/5474713/arizona-allocated-over-340k-in-federal-funding-for-wildfire-defense-programs/" target='_blank' rel="noreferrer">
                               seeking federal funds</a> to protect its 
                               historic treasures and peoples. Gila is as storied as any frontier of the wild west
                               with its tales of horsebacked, gun-swinging guerilla fights and bricked county jails.
                               <br/><br/>
                               Further reading:
                            </p>
                            <ul>
                                <li><a href="https://www.fs.usda.gov/detail/gila/learning/history-culture/?cid=stelprdb5038907" target='_blank' rel="noreferrer">History of the Gila Wilderness</a></li>
                                <li><a href=" https://nationalzoo.si.edu/animals/gila-monster" target='_blank' rel="noreferrer">The Gila Monster</a></li>
                                <li><a href="https://www.history.com/this-day-in-history/geronimo-flees-arizona-reservation" target='_blank' rel="noreferrer">1885, Geronimo the Apache</a></li>  
                            </ul>
                 </>
                        )
    },
    "Graham": {
        "name": "Graham County",
        "text": ( <>
                            <p>
                               Graham county has Mount Graham, where the University of Arizona built the<a href="https://mgio.arizona.edu/" target='_blank' rel="noreferrer">
                                &nbsp;Mount Graham International Observatory. </a>
                               Though Arizona’s clear skies allow for great stargazing all year, Graham’s sparse 
                               population, darker skies, and higher elevations make it an exceptionally 
                               good choice for astronomical observation. Still, environmental concerns and Native American interests made for
                                &nbsp;an interesting public debate surrounding its placement.
                            </p>
                            <p>
                                Safford is the seat of Graham county with a small population of around 10,000 people (see the deep look below).
                                <br/><br/>
                                Further reading:
                            </p>
                            <ul>
                               
                                <li><a href="https://www.eacourier.com/news/graham-county-voters-pass-prop-401/article_1483e3b6-6146-11ed-98c2-af2147360ee2.html" target='_blank' rel="noreferrer">Zoning for Graham's Marijuana greenhouses</a></li>
                            </ul>

                </>
                        )
    },
    "Greenlee": {
        "name": "Greenlee County",
        "text": (  <>
                    <p>
                        The very fewest number of people live here of all of Arizona’s counties. Its largest town and county seat, Clifton, has around 2,500 residents (according to 
                        <a href="https://www.co.greenlee.az.us/demographics/" target='_blank' rel="noreferrer">
                        &nbsp;the county's site</a>). Greenlee exists for mining, and the local government knows it.
                        <br/><br/>
                        Further reading:
                    </p>
                    <ul>

                    </ul>
                </>
                )
    },
    "La Paz": {
        "name": "La Paz County",
        "text": ( <>
                    <p>
                        Situated on the Colorado river, La Paz is known for the Arizonan side of <a href="https://www.usbr.gov/projects/index.php?id=207" target='_blank' rel="noreferrer">
                        Parker Dam</a>, 
                        the deepest in the world. The original La Paz settlement is now <a href="https://en.wikipedia.org/wiki/La_Paz,_Arizona" target='_blank' rel="noreferrer">
                            a ghost town</a>.
                    </p>
                    <p> As hot and dry as its neighbors,
                        this county is very involved in the management of the Colorado River’s water, but 
                        also invests in the interstate-10 boon that is <a href="https://www.rockngem.com/quartzsite-the-hunt-for-rocks-and-history/" target='_blank' rel="noreferrer">
                            Quartzsite</a>, a hotbed for 
                        nomadic travel (
                            <a href="https://www.insider.com/nomadland-the-true-story-of-quartzsite-arizona-rvers-paradise-vanlife-2021-3" target='_blank' rel="noreferrer">
                        accurately depicted in Nomadland</a>) and mineral commerce.
                        <br/><br/>
                        Further reading:
                    </p>
                    <ul>
                        
                    </ul>
                 </>
                )
    },
    "Maricopa": {
        "name": "Maricopa County",
        "text": (<>
                    <p>
                        Maricopa is the <a href="https://www.census.gov/quickfacts/maricopacountyarizona" target='_blank' rel="noreferrer">
                        most populous county of Arizona</a>, with Phoenix as its seat of county and state governance.
                        Rather than a megalopolis that is now the <a a href="https://www.azcentral.com/story/news/local/phoenix/2017/06/11/phoenix-nation-5th-largest-but-real-city/369917001/" target='_blank' rel="noreferrer">
                        5th largest city in the U.S.</a>, the greater Phoenix area is best described 
                        as a mega-suburb where official city boundaries are nearly invisible. If you’re from the mega-burb, you’re from Phoenix, no questions asked, 
                        even if it takes an hour of highways to get from one side to the other. Dynamic, resilient, and growing
                        year over year, Maricopa county is the center of civilization in a desert so increasingly hot that Phoenix sponsors public<a href="https://www.phoenix.gov/heat/resources/heatsafety">
                        &nbsp;cooling stations and enforces renter's rights to good A/C</a>.</p>
                    <p>
                        Downtown 
                        Phoenix saw <a href="https://www.azcentral.com/story/news/local/phoenix/2015/08/05/phoenix-transit-tax-prop-104-demographics/31111575/" target='_blank' rel="noreferrer">
                        600,000 commuters every weekday</a> before 2020. Freeport McMoRan,
                        Banner Health, Petsmart, the Bank of America, and other corporations power the regional economy. Like many downtown areas,
                        the bulk of its enormous workforce commuted in heavy traffic. Now, the post-pandemic collapse of the downtown office market is&nbsp;
                        <a href="https://www.axios.com/local/phoenix/2023/04/10/office-amenities-work-from-home-2023-market-phoenix" target='_blank' rel="noreferrer">
                        forcing real estate investors to offer more</a>.
                    </p>
                    <p> Scottsdale, an enclave for 
                        the rich, is the region’s oasis of luxury shopping as well as a nexus of tech enterprise.
                        Famous for its many spas and gorgeous <a href="https://www.experiencescottsdale.com/itineraries/art-architecture-itinerary/" target='_blank' rel="noreferrer">
                        modern architecture</a>, this strip of
                        manicured desert puts North Phoenix on the map.
                    </p>
                    <p> 
                        A light-rail ride south of Phoenix will bring you straight to Tempe, the sprawling half-city, half-campus of <a href="https://goglobal.asu.edu/international/about-asu-arizona" target='_blank' rel="noreferrer">
                        Arizona State University</a>.
                        With the largest student population in the U.S., ASU's 140,000 students bring immense wealth to this desert outpost.
                        <br/><br/>
                                                Further reading:
                    </p>
                    <ul>
                      
                    </ul>
                </>
                )
    },
    "Mohave": {
        "name": "Mohave County",
        "text": (<>
                    <p>
                        The
                        Mojave desert and people are this county's namesake. Along with a portion of The Grand Canyon, the Colorado River winds through this county so that, 
                        along with La Paz, Mohave benefits from Parker Dam indirectly through Havasu Lake. <a href="https://www.havasuchamber.com/community-profile.html" target='_blank' rel="noreferrer">
                        Lake Havasu</a> is a recreation 
                        town on Havasu Lake with year-round warmth and the original London Bridge.
                    </p>
                    <p>
                        The lake and watersport tourism are a secondary benefit, as Parker Dam was built to service agriculture, with senior water rights held by local tribes. Those tribes agree to sell rights
                        back to areas that need them most (see further reading), using what they get to irrigate the parched dirt made fertile by the region's past as <a href="https://en.wikipedia.org/wiki/Paleontology_in_Arizona" target='_blank' rel="noreferrer">
                        a shallow sea</a>. Agriculture in the area relies on Parker Dam, so its waters must remain level, meaning that Havasu Lake is always filled to the brim and ready to ride, unlike reservoirs farther upstream.
                        <br/><br/>
                        Further reading:
                    </p>
                    <ul>
                        <li><a href="https://www.history.com/news/how-london-bridge-ended-up-in-arizona" target='_blank' rel="noreferrer">Buying the London Bridge</a></li>
                        <li><a href="https://www.parkerpioneer.net/news/article_abf29842-6812-11ec-a49f-8b01f790dd07.html" target='_blank' rel="noreferrer">Water Rights</a></li>
                    </ul>
                </>
                )
    },
    "Navajo": {
        "name": "Navajo County",
        "text": (
                <>
                    <p>
                        The Navajo Nation and 
                        Apache county collaborate and negotiate with the Navajo
                        county government.
                        <a href="https://www.pbs.org/newshour/politics/states-federal-government-want-supreme-court-to-end-navajo-fight-for-colorado-river-water" target='_blank' rel="noreferrer">
                        &nbsp;Like other parts of the lowland deserts, water is scarce here, and populations must find ways to share</a>. In recent years, the politically active Navajo have contested the legality of redistricting
                        that would <a href="https://www.theguardian.com/us-news/2022/may/23/native-americans-arizona-redistricting-congressional-map" target='_blank' rel="noreferrer">
                        dilute their voting power and lessen their influence on these kinds of issues.</a>
                    </p>
                    <p>
                        Shared with Apache county, the Petrified Forest National Park 
                        sees <a href="https://www.nps.gov/pefo/planyourvisit/fast-facts.htm" target='_blank' rel="noreferrer">800,000 visitors a 
                        year</a> who hope to see fossilized remains from an ecological 
                        era more than a<a href="https://www.azcentral.com/story/travel/arizona/2020/11/04/petrified-forest-new-fossil-species-early-mammal-relative/6013206002/" target='_blank' rel="noreferrer">
                        &nbsp;200 million years gone.</a>
                    </p>
                    <p>
                        Navajo county sits squarely (or rectangularly) on the
                        Colorado Plateau, where temperatures are milder but the land 
                        is no less punishing.
                        <br/><br/>
                               Further reading:
                    </p>
                    <ul>
                        
                        <li><a href="https://www.newyorker.com/news/dispatch/the-political-attack-on-the-native-american-vote" target='_blank' rel="noreferrer">Native America and the vote</a></li>
                        <li><a href="https://www.holbrookaz.gov/" target='_blank' rel="noreferrer">Holbrook, county seat</a></li>  
                    </ul>
                </>
                )
    },
    "Pima": {
        "name": "Pima County",
        "text": ( <>
                    <p>
                        This county is best known for
                        Tucson, a university town that transformed into a bustling urban center. Its wetter, cooler 
                        climate and active monsoon seasons keep its famous <a href="https://www.nps.gov/sagu/index.htm" target='_blank' rel="noreferrer">
                            Saguaro National Park</a> a lively cactus-green. The highly 
                        regarded <a href="https://www.arizona.edu/about" target='_blank' rel="noreferrer">
                        University of Arizona</a> hosts a large student population you will find climbing local mountains, 
                        taking stock of wild life for class credit, or otherwise bringin' hip vibes to Tucson's many Sonoran eateries.
                    </p>
                    <p>
                        Much of Pima county's western portion is within the
                        Tohono O'Odham Nation's Reservation. The total land area of this reservation nears that of Connecticut and is where 
                        the Hohokam people historically irrigated land and crossed to reach nearby mountain dwellings.
                    </p>
                    <p>
                        The University of Arizona invests heavily in its world-class astronomy and optics research, partnering with Gila county and multinational operations to 
                        poise itself to lead a future space industry. Still, the city's growth and economy isn't enough to shed its reputation as one of
                        the <a href="https://tucson.com/news/local/tucson-on-list-of-worst-cities-to-live-in-america/article_d5144382-6fdd-11e8-bbc0-474ac863ea82.html" target='_blank' rel="noreferrer">
                        worst places to live in America</a>, even if you won't find any Tucsonian today who would agree.
                        <br/><br/>
                               Further reading:
                    </p>
                    <ul>
                        <li><a href="https://en.wikipedia.org/wiki/Optics_Valley" target='_blank' rel="noreferrer">Tucson, the Optics Valley</a></li>  
                        <li><a href="https://www.britannica.com/topic/University-of-Arizona" target='_blank' rel="noreferrer">Arizona's land-grant university</a></li>  
                    </ul>
                </>
            )
    },
    "Pinal": {
        "name": "Pinal County",
        "text": (<>
                    <p>
                        Formed from <a href="http://genealogytrails.com/ariz/pinal/" target='_blank' rel="noreferrer"> the better known Maricopa and Pima counties</a>, Pinal county boasts agriculture and mining 
                        operations that support both. The agricultural activity of this region is heavily impacted by water scarcity,
                        and long-time farmers have begun engaging with efforts to manage that precious resource.
                        <br/><br/>
                               Further reading:
                    </p>
                    <ul>
                        <li><a href="https://www.npr.org/2023/05/18/1176657700/arizona-farms-running-out-water-farmers-climate-change-colorado-river" target='_blank' rel="noreferrer">Farms run out of water, 2023</a></li>
                        <li><a href="https://censusreporter.org/profiles/05000US04021-pinal-county-az/" target='_blank' rel="noreferrer">A deep look at Pinal</a></li>  
                    </ul>
                </>
                )
    },
    "Santa Cruz": {
        "name": "Santa Cruz County",
        "text": (<>
                    <p>
                        Named for the
                        Santa Cruz River, the seat of county governance is the border town of Nogales.
                        Nogales serving as a port of entry between the U.S. and Mexico, the county and local governments of Santa Cruz are naturally 
                        involved in immigration activities.
                        <br/><br/>
                               Further reading:
                    </p>
                    <ul>
                        <li><a href="https://news.azpm.org/s/96685-migrants-line-up-at-nogales-port-of-entry-hoping-to-seek-asylum/" target='_blank' rel="noreferrer">Asylum seekers in Nogales</a></li> 
                        <li><a href="https://santacruzcountyaz.gov/304/Our-History" target='_blank' rel="noreferrer">A brief history of Santa Cruz</a></li>
                    </ul>
                </>
                )
    },
    "Yavapai": {
        "name": "Yavapai County",
        "text": ( <>
                    <p>
                        Prescott Valley is the former capital of Arizona, <a href="https://www.prescott-az.gov/city-management/history/history-of-prescott/history-in-brief/" target='_blank' rel="noreferrer">
                        founded in 1864. </a>
                        Much of Sedona lies within county borders, including the <a href="https://www.sedonaaz.gov/" target='_blank' rel="noreferrer">
                            city of Sedona</a>. Hiking trails and unique ecologies welcome the nature-minded 
                        visitor, but so do the bars and music venues Prescott is known for. Hip or just hippie, Prescott is a welcoming place.
                        <br/><br/>
                               Further reading:
                    </p>
                    <ul>
                        <li><a href="https://grcahistory.org/history/native-cultures/yavapai-apache/" target='_blank' rel="noreferrer">Yavapai Apache</a></li> 
                        <li><a href="https://www.prescott.com/whiskey-row" target='_blank' rel="noreferrer">Whiskey Row</a></li>
                    </ul>
                </>
                )
    },
    "Yuma": {
        "name": "Yuma County",
        "text": (<>
                    <p>
                        The county seat is the city of Yuma. Yuma is known for its castle-like <a href="https://azstateparks.com/yuma-territorial" target='_blank' rel="noreferrer">
                        territorial prison</a> as well as the <a href="https://www.fws.gov/refuge/kofa" target='_blank' rel="noreferrer">
                        Kofa National Wildlife Refuge</a>. It is the record-holder for  
                        <a  href="https://www.worldrecordacademy.org/2023/3/worlds-sunniest-place-world-record-in-yuma-arizona-423161" target='_blank' rel="noreferrer">
                        &nbsp;the sunniest </a> place on Earth, which also makes managing water resources from the Colorado River crucial to yet another Arizonan county.
                        <br/><br/>
                               Further reading:
                    </p>
                    <ul>
                        <li><a href="https://www.yumacountyaz.gov/visitors/about-the-county" target='_blank' rel="noreferrer">A brief history of Yuma</a></li> 
                    </ul>
                </>
                )
    }
};
